module.exports = __webpack_public_path__ + "logist.png?5dc31a5c1157aa353368afd7f06800f2";


//////////////////
// WEBPACK FOOTER
// ./public/img/products/logist.png
// module id = 566
// module chunks = 3